/**
 * Pure utility functions for time-slot logic.
 * No React, no state — importable anywhere including tests.
 */

/**
 * Parse an "HH:mm" time string into total minutes since midnight.
 * Returns null for falsy input.
 *
 * @param {string} timeStr
 * @returns {number|null}
 */
export function parseTime(timeStr) {
    if (!timeStr) return null;
    const [h, m] = timeStr.split(':').map(Number);
    return h * 60 + m;
}

/**
 * Compare two arrays of strings for strict equality (same length, same order).
 * Treats null/undefined as equal to each other, not equal to an empty array.
 *
 * @param {string[]|null|undefined} a
 * @param {string[]|null|undefined} b
 * @returns {boolean}
 */
export function arraysEqual(a, b) {
    if (!a && !b) return true;
    if (!a || !b) return false;
    if (a.length !== b.length) return false;
    for (let i = 0; i < a.length; i++) {
        if (a[i] !== b[i]) return false;
    }
    return true;
}

/**
 * Check that an array of time frames (already sorted by startTime) are truly
 * consecutive — i.e. each frame's endTime equals the next frame's startTime.
 *
 * Each frame is a tuple: [startTime, endTime, coachPrice, boatPrice]
 * A single-frame (or empty) array is trivially consecutive.
 *
 * @param {Array<[string, string, number, number]>} sortedFrames
 * @returns {boolean}
 */
export function isTrulyConsecutive(sortedFrames) {
    for (let i = 1; i < sortedFrames.length; i++) {
        if (sortedFrames[i - 1][1] !== sortedFrames[i][0]) {
            return false;
        }
    }
    return true;
}
